module.exports = __webpack_public_path__ + "img/img_quit.2cf6b7d9.png";